module.exports = __webpack_public_path__ + "static/media/rightln.732c3f54.png";